import { render, staticRenderFns } from "./RemoteOrder.vue?vue&type=template&id=1a8be9c2&scoped=true"
import script from "./RemoteOrder.vue?vue&type=script&lang=js"
export * from "./RemoteOrder.vue?vue&type=script&lang=js"
import style0 from "./RemoteOrder.vue?vue&type=style&index=0&id=1a8be9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8be9c2",
  null
  
)

export default component.exports